import { put, takeLatest } from 'redux-saga/effects';

import BidService from 'services/bid.service';

import { addBidRoutine, getAdminBidsRoutine, getBidsRoutine, setBidStatusRoutine } from 'state/bid/bid.routines';
import { addBidSuccess, addBidError } from 'state/bid/bid.reducer';

import { NotificationLevel } from 'state/notifications/notifications.reducer';
import { NotificationSystemStore } from 'ui-kit/notification';

import { baseEffectHandler } from 'util/sagas';

export default function* bidsSaga() {
    yield takeLatest(addBidRoutine.TRIGGER, (action) =>
        baseEffectHandler({
            service: BidService.add,
            data: action.payload.bid,
            *onResponse() {
                const { onSuccess } = action.payload;

                yield put(addBidSuccess());

                NotificationSystemStore.addNotification({
                    message: 'Your bid was submitted successfully.',
                    level: NotificationLevel.SUCCESS,
                    title: 'Bid Success'
                });

                if (onSuccess) onSuccess();
            },
            *onError() {
                const { onFailure } = action.payload;

                NotificationSystemStore.addNotification({
                    message: 'Something went wrong while submitting your bid. Try again later.',
                    level: NotificationLevel.WARN,
                    title: 'Bid Failure'
                });

                if (onFailure) onFailure();

                yield put(addBidError());
            }
        })
    );
    yield takeLatest(getAdminBidsRoutine.TRIGGER, (action) =>
        baseEffectHandler({
            service: BidService.getAllAdmin,
            data: action.payload,
            *onResponse(response) {
                yield put(getBidsRoutine.success(response));
            },
            *onError() {
                yield put(getBidsRoutine.failure());
            }
        })
    );
    yield takeLatest(getBidsRoutine.TRIGGER, (action) =>
        baseEffectHandler({
            service: BidService.getAll,
            data: action.payload,
            *onResponse(response) {
                yield put(getBidsRoutine.success(response));
            },
            *onError() {
                yield put(getBidsRoutine.failure());
            }
        })
    );
    yield takeLatest(setBidStatusRoutine.TRIGGER, (action) =>
        baseEffectHandler({
            service: BidService.update,
            data: action.payload,
            *onResponse() {
                yield put(setBidStatusRoutine.success());
                yield put(getBidsRoutine.trigger());
            },
            *onError() {
                yield put(setBidStatusRoutine.failure());
            }
        })
    );
}
